import {
    createSlice
} from "@reduxjs/toolkit";
import { getNotification, getNotificationAll } from "./thunk";
export const initialState = {
    notificationData:[],
    error: "", // for error message
    loading: false,
};

const notificationSlice = createSlice({
    name: "works",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getNotification.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getNotification.fulfilled, (state, action) => {
                state.notificationData = action.payload;
                state.loading = false;
            })
            .addCase(getNotification.rejected, (state, action) => {
                state.error = action.payload ? action.payload?.error : action.error.message;
                state.loading = false;
            })

    }
});

// export const {
//     updateBusinessInfo
// } = businessInfoSlice.actions

export default notificationSlice.reducer;